var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_diii_90_1245)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0753 3.8899C18.3335 3.30881 18.9098 2.93433 19.5457 2.93433C21.0393 2.93433 22.4718 3.52767 23.528 4.58384C24.5841 5.64001 25.1775 7.07248 25.1775 8.56613V9.38644C25.1775 11.007 26.4912 12.3207 28.1117 12.3207H31.1499C31.7684 12.3151 32.3809 12.4434 32.9452 12.6967C33.5127 12.9514 34.018 13.3264 34.4262 13.7958C34.8344 14.2652 35.1356 14.8177 35.309 15.415C35.4824 16.0124 35.5239 16.6403 35.4306 17.2553L33.5802 29.3232C33.5801 29.3237 33.5802 29.3227 33.5802 29.3232C33.4247 30.3458 32.9049 31.2794 32.1168 31.9493C31.3308 32.6173 30.3305 32.9798 29.2993 32.9706H10.1593C9.02132 32.9706 7.92991 32.5185 7.12521 31.7138C6.32051 30.9091 5.86844 29.8177 5.86844 28.6797V19.2934C5.86844 18.1553 6.32051 17.0639 7.12521 16.2592C7.92991 15.4545 9.02132 15.0025 10.1593 15.0025H11.2295C12.389 15.0025 13.4399 14.3196 13.9108 13.26L18.0753 3.8899ZM15.7911 17.5757C15.7911 17.1652 15.8773 16.7592 16.044 16.384L20.1334 7.18301C20.3383 6.72192 20.8956 6.50264 21.2524 6.85943C21.705 7.31208 21.9593 7.92599 21.9593 8.56613V13.9297C21.9593 14.8184 22.6797 15.5388 23.5684 15.5388H31.1579L31.1761 15.5387C31.3316 15.537 31.4856 15.569 31.6275 15.6327C31.7694 15.6964 31.8957 15.7901 31.9978 15.9075C32.0998 16.0248 32.1751 16.163 32.2185 16.3123C32.2618 16.4614 32.2722 16.6182 32.2489 16.7717C32.2489 16.7719 32.249 16.7715 32.2489 16.7717L30.3984 28.8407C30.3596 29.0965 30.2296 29.3297 30.0325 29.4972C29.8354 29.6648 29.5843 29.7554 29.3256 29.7525L18.7253 29.7524C17.1048 29.7524 15.7911 28.4387 15.7911 26.8182V17.5757ZM10.1593 29.7524C11.4923 29.7524 12.573 28.6718 12.573 27.3388V20.6343C12.573 19.3013 11.4923 18.2206 10.1593 18.2206C9.87483 18.2206 9.60198 18.3337 9.4008 18.5348C9.19963 18.736 9.08661 19.0089 9.08661 19.2934V28.6797C9.08661 28.9642 9.19963 29.2371 9.4008 29.4382C9.60198 29.6394 9.87483 29.7524 10.1593 29.7524Z",
    fill: "#AEAEB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_diii_90_1245",
    x: 0.00000810623,
    y: 0.000110865,
    width: 41.3476,
    height: 41.7732,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.93422
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.93422
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_1245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_1245",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.93422
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.46711
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_90_1245"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.93422
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.46711
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.42 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_90_1245",
    result: "effect3_innerShadow_90_1245"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.46711
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.733554
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_90_1245",
    result: "effect4_innerShadow_90_1245"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.49dfc29e84584f7dacc08eb288e8d46d.svg";
export { ForwardRef as ReactComponent };